/** 与 next.config.ts 的 basePath 保持一致（裸 fetch 不会自动加前缀）。 */
export const BASE_PATH = "/hm";

/** 把以 / 开头的站内路径补上 basePath。 */
export function withBasePath(path: string): string {
  if (!path) {
    return BASE_PATH;
  }
  if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("//")) {
    return path;
  }
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (normalized === BASE_PATH || normalized.startsWith(`${BASE_PATH}/`)) {
    return normalized;
  }
  return `${BASE_PATH}${normalized}`;
}
